import { resourceReducer, getResources } from 'redux-resource';
import { reset, httpStatusCodes } from 'redux-resource-plugins';
import metaReducer from './metaReducer';

const orders = resourceReducer('orders', {
  plugins: [reset, metaReducer, httpStatusCodes],
});

export default orders;

export const getOrders = (state, page = 1) =>
  getResources(state, `fetchOrders${page}`);
export const getOrderById = (state, id) => getResources(state, [id])[0];
export const getPurchaseOrders = (state, purchaseId) =>
  getResources(state, `purchaseOrders${purchaseId}`);
